import React from 'react';

export const VenetianWand = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    id="prefix__Layer_1"
    x={0}
    y={0}
    viewBox="0 0 88.4 88.4"
    xmlSpace="preserve"
    {...props}
  >
    <style>
      {
        ".prefix__st5{fill:none;stroke:#26375f;stroke-width:.836;stroke-linecap:round;stroke-linejoin:round}"
      }
    </style>
    <g id="prefix__Layer_2_1_">
      <circle
        cx={44.2}
        cy={44.2}
        r={43.5}
        fill="#fff"
        stroke="#26375f"
        strokeWidth={1.45}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M37.7 74l-5.4 6.3-1.3-.5.6-5.7c0-.2 0-.3.1-.5-.1.1-.1.2-.2.2 0 .1-.1.1-.1.2l-3.8 4.3-1.2-.5.9-8.3 1.1.5c.1.1.2.1.3.2.1.1.1.2.1.3l-.6 4.9c0 .1 0 .2-.1.4l-.1.4.3-.4.3-.3 3.3-3.8c.1-.1.2-.1.2-.1h.3l.4.2c.1 0 .2.1.3.2 0 .1.1.2.1.3l-.5 5c0 .3-.1.5-.1.8.2-.2.3-.5.5-.7l3.1-3.8.2-.2h.3l1 .6zM44.4 82.3l-1.1-.1c-.1 0-.2 0-.3-.1-.1-.1-.1-.2-.2-.2l-.4-1.7-3.3-.3-.8 1.6c0 .1-.1.2-.2.2-.1.1-.2.1-.3.1l-1.2-.1 3.9-7.6 1.5.2 2.4 8zm-2.3-3.2l-.7-2.7-.1-.4c0-.2 0-.3-.1-.5-.1.2-.1.3-.2.5-.1.1-.1.3-.2.4l-1.2 2.5 2.5.2zM52.8 73.2l1.3 7.8-.8.1H53c-.1 0-.2-.1-.3-.2l-5-4.5c.1.2.1.4.1.7l.8 4.8-1.3.2-1.3-7.8.8-.1h.4l.1.1 5 4.5-.1-.4c0-.1 0-.2-.1-.3l-.8-4.8 1.5-.1zM62.8 73c.2.5.4 1 .5 1.6 0 .5 0 1-.2 1.5s-.4.9-.8 1.3-.8.8-1.3 1l-2.7 1.3-3.5-7.1 2.7-1.3c.5-.3 1.1-.4 1.6-.5.5 0 1 0 1.5.2s.9.4 1.3.8c.3.3.6.7.9 1.2zm-1.4.7c-.2-.4-.4-.7-.7-1-.2-.2-.5-.4-.8-.6-.3-.1-.7-.2-1-.2-.3 0-.7.1-1 .3l-1.4.7L59 78l1.4-.7c.3-.2.6-.4.8-.6.2-.2.4-.5.5-.8.1-.3.1-.7.1-1-.1-.5-.2-.9-.4-1.2z" />
      <defs>
        <circle id="prefix__SVGID_1_" cx={44.2} cy={44.2} r={40.4} />
      </defs>
      <clipPath id="prefix__SVGID_2_">
        <use xlinkHref="#prefix__SVGID_1_" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__SVGID_2_)">
        <path
          d="M47.4 68.6l-1.6.6c-.2.1-.4.1-.7.2h-1.6c-.2 0-.5-.1-.7-.2l-1.6-.6c-.3-.2-.5-.5-.4-.9V3c0-1.2.7-2.2 1.5-2.2h4c.8 0 1.5 1 1.5 2.2v64.7c.2.3 0 .7-.4.9z"
          fill="#26375f"
        />
        <path fill="#3e4e6d" d="M42.9 1.5h3.3v67.9h-3.3z" />
        <path fill="#8a9bb7" d="M45.7 1.5h2.2v67.1h-2.2z" />
        <path className="prefix__st5" d="M45.7 68.9V1M42.9 68.9V1" />
        <path
          d="M47.4 68.6l-1.6.6c-.2.1-.4.1-.7.2h-1.6c-.2 0-.5-.1-.7-.2l-1.6-.6c-.3-.2-.5-.5-.4-.9V3c0-1.2.7-2.2 1.5-2.2h4c.8 0 1.5 1 1.5 2.2v64.7c.2.3 0 .7-.4.9z"
          fill="none"
          stroke="#26375f"
          strokeWidth={1.15}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <circle
        cx={44.2}
        cy={44.2}
        r={43.5}
        fill="none"
        stroke="#26375f"
        strokeWidth={1.45}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
  );
};
